/* eslint-disable no-plusplus, no-bitwise */

export function hashCode(str) {
  let hash = 0;
  if (!str) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function getBrandedAvatarDataUrl(indexOrSeed) {
  let index;
  if (typeof indexOrSeed === 'number') {
    index = Math.abs(indexOrSeed) % 24;
  } else {
    // If it's a numeric string (like '3')
    const parsed = parseInt(indexOrSeed, 10);
    if (!Number.isNaN(parsed) && String(parsed) === String(indexOrSeed)) {
      index = Math.abs(parsed) % 24;
    } else {
      index = Math.abs(hashCode(indexOrSeed || '')) % 24;
    }
  }
  return `/avatars/3d_avatar_${index + 1}.png`;
}

